import {paramFaq} from "@/models/Params";
import _APIInstance from "@/config/configApi";
import {API} from "@constants/common";

export default class FaqServices {

  static async getAllFaq(params: paramFaq,lang:string | undefined): Promise<any> {
    return await _APIInstance
      .get(`${API.FAQ.GET_ALL}`, {
        params: params,
        headers:{
          "lang": lang,
        }
      })
      .then((res) => {
        return Promise.resolve(res.data.data);
      })
      .catch((e) => {
        return Promise.reject(e?.response?.data);
      });
  }
}